import { apolloClient } from "config/apollo";
import { gql } from "config/graphql";
import { IFlow } from "config/types";

export type IFlowResponse = { flow: Pick<IFlow, "id" | "terminalBehavior" | "slug"> };

export const flowQuery = (slug: IFlow["slug"]) => {
  const query = gql`
    query Flow($slug: String!) {
      flow(slug: $slug) {
        id
        terminalBehavior
        slug
      }
    }
  `;

  return apolloClient.query<IFlowResponse>({
    variables: { slug },
    query,
  });
};
